import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const edlManager = defineConnector({
  identifier: "edlManager",
  name: "EDL Manager",
  tagLine: "External dynamic list management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://edlmanager\\.com/api/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "Api-Key",
      },
    ]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [EDL Manager](https://edlmanager.com/), generate an API key. See the [API documentation](https://support.edlmanager.com/support/solutions/articles/70000636857-edl-manager-api) for details.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "EDL Manager API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://edlmanager.com/api/v1/sources/manual/",
  },
});
